import React from 'react'
import { CrossClientQueryResultCellProps } from './types'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientClients, selectCrossClientTeammates, selectCrossClientTeammatesLoading } from '../../../../store/crossClient/crossClientResults'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { getOwnerLabel } from '../../utils'

export const CrossClientQueryResultOwnerCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const teammates = useAppSelector(selectCrossClientTeammates)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)

  const teammatesLoading = useAppSelector(selectCrossClientTeammatesLoading)

  if (teammatesLoading) {
    return <div className='skeleton pt-2 zocks-border-0.5' style={{ width: '30%', height: '30px' }}></div>
  }

  const client = clients[result.clientId]
  const ownerId = client?.owner?.ownerId ?? null

  return <div className='paragraph-medium'>{getOwnerLabel(currentUser, teammates, ownerId)}</div>
}
